import React, { useState, useEffect } from 'react';

const ToastContext = ({ message, type, isVisible }) => {
  const [isRendered, setIsRendered] = useState(false);
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setIsRendered(true), 10);
      return () => clearTimeout(timer);
    } else {
      setIsRendered(false);
    }
  }, [isVisible]);
  if (!isVisible) return null;
  const style = {
    position: 'fixed',
    top: '60px',
    right: '20px',
    zIndex: 10000,
    backgroundColor: type === 'success' ? '#4CAF50' : type === 'error' ? '#ef4444' : '#f59e0b',
    color: 'white',
    padding: '14px 28px',
    borderRadius: '12px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2)',
    fontWeight: '600',
    fontSize: '13px',
    minWidth: '220px',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    opacity: isRendered ? 1 : 0,
    transform: isRendered ? 'translateY(0)' : 'translateY(-20px)',
  };
  return <div style={style}>{message}</div>;
};

export default ToastContext;